"use client";

import type { ReactNode } from "react";
import styles from "./SettingsField.module.css";

export interface SettingsFieldProps {
  label?: string;
  /**
   * Long-form explanation. Sits between the label and the control, which is
   * why the controls below don't use their own `label` prop.
   */
  description?: ReactNode;
  /**
   * Id of the control this field describes. Omit for groups (checkbox lists,
   * card pickers) that have no single focusable target — the label then
   * renders as plain text rather than a dangling `<label>`.
   */
  htmlFor?: string;
  children: ReactNode;
}

/**
 * The label + description + control stack used throughout the Settings modal.
 * Local to Settings rather than `/src/ui`: it encodes this modal's copy-heavy
 * layout, not a general form primitive.
 */
export default function SettingsField({
  label,
  description,
  htmlFor,
  children,
}: SettingsFieldProps) {
  return (
    <div className={styles.field}>
      {label &&
        (htmlFor ? (
          <label className={styles.label} htmlFor={htmlFor}>
            {label}
          </label>
        ) : (
          <span className={styles.label}>{label}</span>
        ))}
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </div>
  );
}
